export enum ApiErrorCode {
  ERROR_UNKNOWN = 'ERROR_UNKNOWN',
  ERROR_TIMEOUT = 'ERROR_TIMEOUT',
  ERROR_NOT_ENOUGH_BALANCE = 'ERROR_NOT_ENOUGH_BALANCE',
  ERROR_TOKEN_ALREADY_EXISTS = 'ERROR_TOKEN_ALREADY_EXISTS',
  ERROR_CUSTOMER_NOT_EXISTS = 'ERROR_CUSTOMER_NOT_EXISTS',
  ERROR_CUSTOMER_BLOCKED = 'ERROR_CUSTOMER_BLOCKED',
  ERROR_PLAYER_LOCKED = 'ERROR_PLAYER_LOCKED',
  ERROR_CURRENCY_NOT_EXISTS = 'ERROR_CURRENCY_NOT_EXISTS',
  ERROR_CURRENCY_NOT_ENABLED_FOR_OPERATOR = 'ERROR_CURRENCY_NOT_ENABLED_FOR_OPERATOR',
  ERROR_CURRENCY_IS_BLOCKED_FOR_OPERATOR = 'ERROR_CURRENCY_IS_BLOCKED_FOR_OPERATOR',
  ERROR_IP_BLOCKED = 'ERROR_IP_BLOCKED',
  ERROR_COUNTRY_BLOCKED = 'ERROR_COUNTRY_BLOCKED',
  ERROR_CREATE_DEMO_NOT_EXISTS = 'ERROR_CREATE_DEMO_NOT_EXISTS',
  ERROR_VALIDATE_SIGNATURE_CUSTOMER_NOT_EXISTS = 'ERROR_VALIDATE_SIGNATURE_CUSTOMER_NOT_EXISTS',
  ERROR_CURRENCY_DIFFERENT_THAN_SESSION_CURRENCY = 'ERROR_CURRENCY_DIFFERENT_THAN_SESSION_CURRENCY',
  ERROR_CURRENCY_DIFFERENT_THAN_OPERATOR_CURRENCY = 'ERROR_CURRENCY_DIFFERENT_THAN_OPERATOR_CURRENCY',
  ERROR_PLAYER_DIFFERENT_THAN_OPERATOR_PLAYER = 'ERROR_PLAYER_DIFFERENT_THAN_OPERATOR_PLAYER',
  ERROR_BET_LOWER_THEN_MIN = 'ERROR_BET_LOWER_THEN_MIN',
  ERROR_BET_HIGHER_THEN_MAX = 'ERROR_BET_HIGHER_THEN_MAX',
  ERROR_GAMEROUND_NOT_EXISTS = 'ERROR_GAMEROUND_NOT_EXISTS',
  ERROR_WIN_HIGHER_THEN_MAX = 'ERROR_WIN_HIGHER_THEN_MAX',
  ERROR_START_GAME_NOT_EXISTS = 'ERROR_START_GAME_NOT_EXISTS',
  ERROR_UPDATE_SESSION_SESSION_NOT_EXISTS = 'ERROR_UPDATE_SESSION_SESSION_NOT_EXISTS',
  ERROR_UPDATE_SESSION_NEGATIVE_BALANCE = 'ERROR_UPDATE_SESSION_NEGATIVE_BALANCE',
  ERROR_SAVE_REFUND_BET_NOT_EXISTS = 'ERROR_SAVE_REFUND_BET_NOT_EXISTS',
  ERROR_SAVE_WIN_BET_NOT_EXISTS = 'ERROR_SAVE_WIN_BET_NOT_EXISTS',
  ERROR_BET_HAS_NOT_AUTOCASHOUT = 'ERROR_BET_HAS_NOT_AUTOCASHOUT',
  ERROR_BET_AUTOCASHOUT_MUST_BE_POSITIVE = 'ERROR_BET_AUTOCASHOUT_MUST_BE_POSITIVE',
  ERROR_MULTIPLIER_HIGHER_THAN_CALCULATED = 'ERROR_MULTIPLIER_HIGHER_THAN_CALCULATED',
  ERROR_GAMEROUND_ALREADY_STARTED = 'ERROR_GAMEROUND_ALREADY_STARTED',
  ERROR_CASHOUT_GAMEROUND_NOT_ACTIVE = 'ERROR_CASHOUT_GAMEROUND_NOT_ACTIVE',
  ERROR_CASHOUT_BEFORE_GAME_START = 'ERROR_CASHOUT_BEFORE_GAME_START',
  ERROR_CASHOUT_AFTER_GAMEROUND_END = 'ERROR_CASHOUT_AFTER_GAMEROUND_END',
  ERROR_BET_NOT_FOUND = 'ERROR_BET_NOT_FOUND',
  ERROR_BET_ALREADY_HAS_CASHOUT = 'ERROR_BET_ALREADY_HAS_CASHOUT',
  ERROR_BET_ALREADY_HAS_REFUND = 'ERROR_BET_ALREADY_HAS_REFUND',
  ERROR_NOT_ENOUGH_MONEY = 'ERROR_NOT_ENOUGH_MONEY',
  ERROR_PLAYER_ALREADY_PLACE_TWO_BETS = 'ERROR_PLAYER_ALREADY_PLACE_TWO_BETS',
  ERROR_CACHE_CUSTOMERS = 'ERROR_CACHE_CUSTOMERS',
  ERROR_PLAYER_DOES_NOT_HAVE_BETS = 'ERROR_PLAYER_DOES_NOT_HAVE_BETS',
  ERROR_GAME_ROUND_DOES_NOT_HAVE_BETS = 'ERROR_GAME_ROUND_DOES_NOT_HAVE_BETS',
  ERROR_BET_NOT_EXISTS = 'ERROR_BET_NOT_EXISTS',
  ERROR_CACHE_DOES_NOT_CONTAIN_BETS = 'ERROR_CACHE_DOES_NOT_CONTAIN_BETS',
  ERROR_CACHE_DOES_NOT_CONTAIN_TOWERS = 'ERROR_CACHE_DOES_NOT_CONTAIN_TOWERS',
  ERROR_CACHE_DOES_NOT_CONTAIN_MINES = 'ERROR_CACHE_DOES_NOT_CONTAIN_MINES',
  ERROR_GAME_DOES_NOT_EXISTS = 'ERROR_GAME_DOES_NOT_EXISTS',
  ERROR_SESSION_NOT_EXISTS = 'ERROR_SESSION_NOT_EXISTS',
  ERROR_TOWERS_INVALID_PATTERN = 'ERROR_TOWERS_INVALID_PATTERN',
  ERROR_MINES_INVALID_PATTERN = 'ERROR_MINES_INVALID_PATTERN',
  ERROR_TOWERS_CASHOUT_WITHOUT_PICKS = 'ERROR_TOWERS_CASHOUT_WITHOUT_PICKS',
  ERROR_MINES_CASHOUT_WITHOUT_PICKS = 'ERROR_MINES_CASHOUT_WITHOUT_PICKS',
  ERROR_TOWERS_INVALID_PICK = 'ERROR_TOWERS_INVALID_PICK',
  ERROR_INVALID_MIN_BET = 'ERROR_INVALID_MIN_BET',
  ERROR_INVALID_MAX_BET = 'ERROR_INVALID_MAX_BET',
}
